import {TopicFragment} from '@generated/graphql';

/**
 * Generic type guard that checks whether an object has truthy `link` and `label` properties.
 * Works for HeaderLinkFieldsFragment, HeaderSubLinkFieldsFragment,
 * FooterLinkFieldsFragment, InformationLinkButtonFieldsFragment, etc.
 */
export function hasLinkAndLabel<T extends { link?: string | null; label?: string | null }>(
  value: T | null | undefined,
): value is T & { link: string; label: string } {
  return !!value?.link && !!value?.label;
}

export type TopicWithLabel = TopicFragment & {
  label: string;
  topic: string;
};

export const topicHasTopicAndLabel = (
  topic: TopicFragment | null | undefined
): topic is TopicWithLabel => {
  return topic != null && topic.topic != null && topic.label != null;
};
